import React from 'react';
import { Button } from './ui/button';
import { Shield, Award } from 'lucide-react';
import { openChat } from '../utils/chat';

export const Hero = ({ onOpenForm }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1730629689669-5567c3d00ad5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGxlZ2FsfGVufDB8fHx8MTc2MDc2MDMyNHww&ixlib=rb-4.1.0&q=85)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1F44]/95 via-[#0A1F44]/85 to-[#0A1F44]/75"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="space-y-8">
          {/* Badge */}
          <div className="flex justify-center">
            <div className="inline-flex items-center space-x-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full px-4 py-2">
              <Award className="w-5 h-5 text-[#D4AF37]" />
              <span className="text-[#D4AF37] text-sm font-medium">Trusted IP Law Experts</span>
            </div>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
            Protect Your Brand.
            <br />
            <span className="text-[#D4AF37]">Preserve Your Rights.</span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Trademark Liberty provides expert legal assistance in trademarks, copyrights, patents, and company formation — ensuring your intellectual property remains exclusively yours.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6">
            <Button 
              onClick={onOpenForm}
              className="liquid bg-[#D4AF37] hover:bg-[#B8941F] text-[#0A1F44] font-bold px-8 py-6 text-lg"
            >
              Start Trademark Registration
            </Button>
            <Button
              onClick={openChat}
              variant="outline"
              className="js-chat liquid-outline border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0A1F44] font-bold px-8 py-6 text-lg"
            >
              Discuss with Attorney
            </Button>
          </div>

        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#D4AF37] rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-[#D4AF37] rounded-full"></div>
        </div>
      </div>
    </section>
  );
};